var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrganizationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.533 18.967C19.963 19.826 19.164 20.517 18.224 20.963H19.876C20.497 20.963 20.999 20.463 20.999 19.845C21 19.477 20.813 19.165 20.533 18.967Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.221 19.2141H10.214C9.31504 19.2141 8.58403 18.4851 8.58403 17.5881V13.9691C8.58403 13.0721 9.31404 12.3411 10.214 12.3411H11.32C11.604 11.9821 11.929 11.6581 12.291 11.3761H8.27003C7.93403 11.3761 7.66203 11.1051 7.66203 10.7701V9.02207C7.66203 8.68807 7.93403 8.41607 8.27003 8.41607H15.728C16.064 8.41607 16.335 8.68707 16.335 9.02207V10.1981C17.062 10.2671 17.747 10.4761 18.37 10.7931V4.64108C18.37 2.93708 17.786 2.99906 17.786 2.99906C17.464 2.99906 17.202 3.25907 17.202 3.58207V6.66407C16.977 5.92407 16.548 5.12608 16.052 5.12608H7.94603C7.44803 5.12608 7.01903 5.92506 6.79303 6.66506V3.58207C6.79303 3.26007 6.53203 2.99906 6.20903 2.99906C6.20903 2.99906 5.62604 2.99908 5.62604 4.64108V14.0691H5.15002C4.41902 14.0691 3.82603 14.6601 3.82603 15.3881V18.7271C3.82603 18.7481 3.83604 18.7641 3.83704 18.7841C3.35904 18.9111 2.99902 19.3271 2.99902 19.8441C2.99902 20.4621 3.50003 20.9621 4.12003 20.9621H13.349C12.504 20.5611 11.774 19.9581 11.221 19.2141ZM6.44102 18.4971C5.83702 18.4971 5.34602 18.0081 5.34602 17.4031C5.34602 16.8011 5.83602 16.3121 6.44102 16.3121C7.04602 16.3121 7.53603 16.8011 7.53603 17.4031C7.53603 18.0081 7.04602 18.4971 6.44102 18.4971Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4122 13.743V10.687C14.8072 11.023 14.2192 12.14 13.9332 13.743H15.4122Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4122 21.0001V17.9451H13.9332C14.2192 19.5471 14.8072 20.6651 15.4122 21.0001Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7562 15.8439C13.7562 16.3189 13.7852 16.7709 13.8302 17.1979H15.4122V14.4919H13.8302C13.7852 14.9179 13.7562 15.3679 13.7562 15.8439Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4032 13.743H20.5512C19.9552 12.407 18.8152 11.366 17.4082 10.906C17.8652 11.591 18.2132 12.572 18.4032 13.743Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8152 17.197C20.9322 16.764 21.0012 16.312 21.0012 15.843C21.0012 15.375 20.9332 14.923 20.8152 14.49H18.5002C18.5432 14.923 18.5662 15.375 18.5662 15.843C18.5662 16.312 18.5432 16.764 18.5002 17.197H20.8152Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6412 13.743C17.3562 12.14 16.7682 11.023 16.1622 10.687V13.743H17.6412Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1722 17.9451H11.0232C11.6182 19.2811 12.7602 20.3221 14.1642 20.7811C13.7092 20.0961 13.3622 19.1161 13.1722 17.9451Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4032 17.9451C18.2142 19.1161 17.8662 20.0951 17.4092 20.7811C18.8152 20.3221 19.9582 19.2811 20.5542 17.9451H18.4032Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7602 14.491C10.6432 14.924 10.5752 15.376 10.5752 15.844C10.5752 16.313 10.6422 16.765 10.7602 17.198H13.0742C13.0312 16.765 13.0062 16.313 13.0062 15.844C13.0062 15.376 13.0312 14.924 13.0742 14.491H10.7602Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1722 13.743C13.3612 12.572 13.7092 11.592 14.1642 10.906C12.7602 11.366 11.6182 12.407 11.0242 13.743H13.1722Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8172 15.844C17.8172 15.368 17.7902 14.918 17.7452 14.491H16.1632V17.197H17.7452C17.7892 16.771 17.8172 16.318 17.8172 15.844Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1622 17.9451V21.0001C16.7672 20.6651 17.3552 19.5471 17.6412 17.9451H16.1622Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganizationIcon);
export default __webpack_public_path__ + "static/media/organization-icon.323c144c6947897baa7e9bd5bf2c8547.svg";
export { ForwardRef as ReactComponent };